module.exports = __webpack_public_path__ + "viasat-hockey-0b8a233b5022aea8b9967f5b3c964819.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/logos/viasat-hockey.jpg
// module id = 1157
// module chunks = 0 1